import withTranslation from '../../../globals/components/withTranslation'
import Component from './component'
import { AddUserReviewProps } from './types'

export default withTranslation(Component) as React.ComponentClass<AddUserReviewProps>
